module.exports = __webpack_public_path__ + "img/icon-4.b1719fca.png";